import { SpecialHoursInputEntry } from './types';

const DAY_DURATION_MIN = 24 * 60;

export const DEFAULT_TIME_PAIR = {
  endMinutes: DAY_DURATION_MIN,
  startMinutes: 0,
};

export const EMPTY_SPECIAL_HOURS_INPUT_ENTRY: SpecialHoursInputEntry = {
  closedAllDay: false,
  open24Hours: false,
  timePairs: [{ endMinutes: DAY_DURATION_MIN, startMinutes: 0 }],
  periods: [],
  message: '',
};
